var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';
export class IRIProjectEvaluationDraftTIPReportComponent {
    constructor(reportsApi, reportHelper, route, titleService) {
        this.reportsApi = reportsApi;
        this.reportHelper = reportHelper;
        this.route = route;
        this.isGenerating = false;
        this.reportParams = {
            countyNumber: null,
            districtNumber: null,
            municipalId: null,
            congressDistrictNumber: null,
            senateDistrictNumber: null,
            houseDistrictNumber: null,
            projectIds: null,
            tipType: 'P',
            planningPartner: null
        };
        this.todaysDate = new Date().toDateString();
        this.error = false;
        this.errorMessage = this.reportHelper.reportErrorMessages.noReportData;
        titleService.setTitle(titleService.getTitle() + ' : IRI Project Evaluation Draft TIP Report');
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isGenerating = true;
            this.route.paramMap.subscribe(x => {
                const params = JSON.parse(window.localStorage.getItem(x.get('id')));
                this.reportParams.countyNumber = params.countyNumber;
                this.reportParams.districtNumber = params.districtNumber;
                this.reportParams.congressDistrictNumber = params.congressDistrictNumber;
                this.reportParams.senateDistrictNumber = params.senateDistrictNumber;
                this.reportParams.houseDistrictNumber = params.houseDistrictNumber;
                this.reportParams.projectIds = params.projectIds;
                this.reportParams.planningPartner = params.planningPartnerShortName;
                this.planningPartnerShortName = params.planningPartnerShortName;
                this.countyMunicipalityCode = params.countyMunicipalityCode;
                this.loadReport();
            });
        });
    }
    loadReport() {
        this.isGenerating = true;
        return this.reportsApi.getIRIProjectEvaluationDraftTIPReportData(this.reportParams).then((reportData) => {
            this.reportData = reportData;
            this.calculateTotalMiles();
            this.getSearchLocation();
            this.isGenerating = false;
        }, (error) => {
            this.isGenerating = false;
            this.error = true;
        });
    }
    calculateTotalMiles() {
        let total = 0;
        const data = this.reportData.projectEvaluationSummary;
        for (const key in data) {
            if (data[key].miles) {
                total += parseFloat(data[key].miles);
            }
        }
        this.totalMiles = total.toFixed(2);
    }
    // split municipality code out to send to report
    getMunicipalityCode() {
        if (this.countyMunicipalityCode) {
            const startIndex = 2;
            return this.countyMunicipalityCode.substring(startIndex);
        }
        else {
            return undefined;
        }
    }
    getSearchLocation() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.reportParams.countyNumber) {
                this.searchLocation = yield this.reportHelper.getCountyNameFromId(parseInt(this.reportParams.countyNumber, 10));
            }
            if (this.reportParams.districtNumber) {
                this.searchLocation = 'District ' + this.reportParams.districtNumber;
            }
            if (this.reportParams.municipalId) {
                this.searchLocation = yield this.reportHelper.getMunicipalNameFromId([this.reportParams.countyNumber], parseInt(this.reportParams.municipalId, 10));
            }
            if (this.reportParams.congressDistrictNumber) {
                yield this.reportHelper.getCongressionalDistrictByName(parseInt(this.reportParams.congressDistrictNumber, 10)).then((data) => {
                    this.searchLocation = data.title;
                });
            }
            if (this.reportParams.senateDistrictNumber) {
                yield this.reportHelper.getSenateDistrictByName(parseInt(this.reportParams.senateDistrictNumber, 10)).then((data) => {
                    this.searchLocation = data.title;
                });
            }
            if (this.reportParams.houseDistrictNumber) {
                yield this.reportHelper.getHouseDistrictByName(parseInt(this.reportParams.houseDistrictNumber, 10)).then((data) => {
                    this.searchLocation = data.title;
                });
            }
            if (this.planningPartnerShortName) {
                this.searchLocation = this.planningPartnerShortName + '(MPO/RPO)';
            }
        });
    }
}
